import {
    PropertyKeyAccessType,
    type PropertyKeyModel, PropertyKeyType,
} from '@/models/property-keys'

import type { PropertyKey } from '../types/property-keys'

function sortKeysBySequence(keys: PropertyKeyModel[]) {
    {
        const sorted = [...keys]

        sorted.sort((keyA, keyB) => {
            if (keyA.sequenceNumber < keyB.sequenceNumber) {
                return -1
            }

            if (keyA.sequenceNumber > keyB.sequenceNumber) {
                return 1
            }

            return 0
        })

        return sorted
    }
}

function transformPropertyKeyType(type: string) : PropertyKeyType {
    switch (type) {
        case 'property-entrance-door': {
            return PropertyKeyType.PropertyEntrance;
        }

        case 'property-elevator-door': {
            return PropertyKeyType.PropertyElevatorDoor;
        }

        case 'property-unit-door': {
            return PropertyKeyType.PropertyUnit;
        }

        case 'property-hallway-door': {
            return PropertyKeyType.PropertyHallway;
        }

        case 'property-luggage-door': {
            return PropertyKeyType.PropertyLuggage;
        }

        case 'property-washeteria-door': {
            return PropertyKeyType.PropertyWashateria;
        }

        case 'property-kitchen-door': {
            return PropertyKeyType.PropertyKitchen;
        }

        default: {
            return PropertyKeyType.Unknown;
        }
    }
}

function transformPropertyKey(propertyKey: PropertyKey): PropertyKeyModel {
    const sequenceNumber = propertyKey.sequenceNumber ?? 0
    const type = transformPropertyKeyType(propertyKey.type)

    // Code access
    if (propertyKey.accessType === 'code' || propertyKey.code !== null) {
        return {
            sequenceNumber,
            accessType: PropertyKeyAccessType.Code,
            type,
            code: propertyKey.code,
            id: propertyKey.id,
            name: propertyKey.name,
            validFromDate: propertyKey.validFromDate,
            validToDate: propertyKey.validToDate,
            deletedAt: propertyKey.deletedAt,
        }
    }


    // Physical access
    if (propertyKey.accessType === 'physical') {
        return {
            sequenceNumber,
            id: propertyKey.id,
            name: propertyKey.name,
            accessType: PropertyKeyAccessType.Physical,
            type,
            validFromDate: propertyKey.validFromDate,
            validToDate: propertyKey.validToDate,
            deletedAt: propertyKey.deletedAt,
        }
    }

    // Remote access
    if (propertyKey.accessType === 'remote') {
        return {
            sequenceNumber,
            accessType: PropertyKeyAccessType.Remote,
            type,
            id: propertyKey.id,
            name: propertyKey.name,
            validFromDate: propertyKey.validFromDate,
            validToDate: propertyKey.validToDate,
            deletedAt: propertyKey.deletedAt,
        }
    }

    // Return default in case accessType not set
    return {
        sequenceNumber,
        accessType: null,
        type,
        id: propertyKey.id,
        name: propertyKey.name,
        validFromDate: propertyKey.validFromDate,
        validToDate: propertyKey.validToDate,
        deletedAt: propertyKey.deletedAt,
    }
}

export function transformPropertyKeys(propertyKeys: PropertyKey[]): PropertyKeyModel[] {
    const transformedPropertyKeys = propertyKeys
        .map(transformPropertyKey)

    if (transformedPropertyKeys.length === 1) {
        return transformedPropertyKeys
    }

    return sortKeysBySequence(transformedPropertyKeys)
}
